import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { "clip-path": "url(#clip0_3510_5415)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3510_5415" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      fill: "white"
    })
  ])
], -1)

import { PropType, ref, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'printIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
  width: {
    type: Number as PropType<number>,
    default: 18,
  },
  height: {
    type: Number as PropType<number>,
    default: 18,
  },
  isHover: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const color = ref(props.color);

watch(
  () => props.isHover,
  (value) => {
    if (value) {
      hoverColor();
    } else {
      normalColor();
    }
  },
);

const hoverColor = () => {
  color.value = "#387DFF";
};
const normalColor = () => {
  color.value = props.color;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 18 18",
    fill: "none",
    onMouseover: hoverColor,
    onMouseleave: normalColor
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M4.3125 4.5C4.51141 4.5 4.70218 4.42098 4.84283 4.28033C4.98348 4.13968 5.0625 3.94891 5.0625 3.75V1.5H11.6925L13.3125 3.12V3.75C13.3125 3.94891 13.3915 4.13968 13.5322 4.28033C13.6728 4.42098 13.8636 4.5 14.0625 4.5C14.2614 4.5 14.4522 4.42098 14.5928 4.28033C14.7335 4.13968 14.8125 3.94891 14.8125 3.75V2.8125C14.8171 2.70879 14.8002 2.60525 14.7628 2.50843C14.7253 2.4116 14.6682 2.3236 14.595 2.25L12.75 0.4425C12.47 0.160809 12.0897 0.00167459 11.6925 0L5.0625 0C4.66468 0 4.28314 0.158035 4.00184 0.43934C3.72054 0.720644 3.5625 1.10218 3.5625 1.5V3.75C3.5625 3.94891 3.64152 4.13968 3.78217 4.28033C3.92282 4.42098 4.11359 4.5 4.3125 4.5Z",
        fill: color.value
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M16.125 5.25H1.875C1.37772 5.25 0.900805 5.44754 0.549175 5.79917C0.197544 6.15081 0 6.62772 0 7.125L0 10.5C0 10.9973 0.197544 11.4742 0.549175 11.8258C0.900805 12.1775 1.37772 12.375 1.875 12.375H3.75V17.0625C3.75 17.1856 3.77425 17.3075 3.82136 17.4213C3.86848 17.535 3.93753 17.6384 4.02459 17.7254C4.11164 17.8125 4.21499 17.8815 4.32873 17.9286C4.44248 17.9758 4.56439 18 4.6875 18H13.6875C13.8106 18 13.9325 17.9758 14.0463 17.9286C14.16 17.8815 14.2634 17.8125 14.3504 17.7254C14.4375 17.6384 14.5065 17.535 14.5536 17.4213C14.6008 17.3075 14.625 17.1856 14.625 17.0625V12.375H16.125C16.3712 12.375 16.615 12.3265 16.8425 12.2323C17.07 12.138 17.2767 11.9999 17.4508 11.8258C17.6249 11.6517 17.763 11.445 17.8573 11.2175C17.9515 10.99 18 10.7462 18 10.5V7.125C18 6.87877 17.9515 6.63495 17.8573 6.40747C17.763 6.17998 17.6249 5.97328 17.4508 5.79917C17.2767 5.62506 17.07 5.48695 16.8425 5.39273C16.615 5.2985 16.3712 5.25 16.125 5.25ZM2.625 8.625C2.47666 8.625 2.33166 8.58101 2.20832 8.4986C2.08499 8.41619 1.98886 8.29906 1.93209 8.16201C1.87532 8.02497 1.86047 7.87417 1.88941 7.72868C1.91835 7.5832 1.98978 7.44956 2.09467 7.34467C2.19956 7.23978 2.3332 7.16835 2.47868 7.13941C2.62417 7.11047 2.77497 7.12532 2.91201 7.18209C3.04906 7.23886 3.16619 7.33499 3.2486 7.45832C3.33101 7.58166 3.375 7.72666 3.375 7.875C3.375 8.07391 3.29598 8.26468 3.15533 8.40533C3.01468 8.54598 2.82391 8.625 2.625 8.625ZM13.125 16.125C13.125 16.2245 13.0855 16.3198 13.0152 16.3902C12.9448 16.4605 12.8495 16.5 12.75 16.5H5.625C5.52554 16.5 5.43016 16.4605 5.35984 16.3902C5.28951 16.3198 5.25 16.2245 5.25 16.125V9.375C5.25 9.27554 5.28951 9.18016 5.35984 9.10983C5.43016 9.03951 5.52554 9 5.625 9H12.75C12.8495 9 12.9448 9.03951 13.0152 9.10983C13.0855 9.18016 13.125 9.27554 13.125 9.375V16.125Z",
        fill: color.value
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M11.25 11.0625H7.125C6.97582 11.0625 6.83274 11.1218 6.72725 11.2273C6.62176 11.3327 6.5625 11.4758 6.5625 11.625C6.5625 11.7742 6.62176 11.9173 6.72725 12.0227C6.83274 12.1282 6.97582 12.1875 7.125 12.1875H11.25C11.3992 12.1875 11.5423 12.1282 11.6477 12.0227C11.7532 11.9173 11.8125 11.7742 11.8125 11.625C11.8125 11.4758 11.7532 11.3327 11.6477 11.2273C11.5423 11.1218 11.3992 11.0625 11.25 11.0625Z",
        fill: color.value
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M9.9375 13.6875H7.125C6.97582 13.6875 6.83274 13.7468 6.72725 13.8523C6.62176 13.9577 6.5625 14.1008 6.5625 14.25C6.5625 14.3992 6.62176 14.5423 6.72725 14.6477C6.83274 14.7532 6.97582 14.8125 7.125 14.8125H9.9375C10.0867 14.8125 10.2298 14.7532 10.3352 14.6477C10.4407 14.5423 10.5 14.3992 10.5 14.25C10.5 14.1008 10.4407 13.9577 10.3352 13.8523C10.2298 13.7468 10.0867 13.6875 9.9375 13.6875Z",
        fill: color.value
      }, null, 8, _hoisted_6)
    ]),
    _hoisted_7
  ], 40, _hoisted_1))
}
}

})